import React, { useState, useEffect } from "react";

const LinkUploader = () => {
  const [className, setClassName] = useState("6");
  const [subject, setSubject] = useState("");
  const [url, setUrl] = useState("");
  const [dataList, setDataList] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [view, setView] = useState("grid"); // "grid" or "form"

  useEffect(() => {
    const stored = localStorage.getItem("classLinks");
    if (stored) {
      setDataList(JSON.parse(stored));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("classLinks", JSON.stringify(dataList));
  }, [dataList]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!subject.trim() || !url.trim()) {
      alert("Please fill in all fields.");
      return;
    }

    const newItem = {
      id: editingId || Date.now(),
      className,
      subject,
      url,
    };

    if (editingId) {
      setDataList((prev) =>
        prev.map((item) => (item.id === editingId ? newItem : item))
      );
    } else {
      setDataList((prev) => [...prev, newItem]);
    }

    setClassName("6");
    setSubject("");
    setUrl("");
    setEditingId(null);
    setView("grid");
  };

  const handleEdit = (item) => {
    setClassName(item.className);
    setSubject(item.subject);
    setUrl(item.url);
    setEditingId(item.id);
    setView("form");
  };

  const handleDelete = (id) => {
    const updated = dataList.filter((item) => item.id !== id);
    setDataList(updated);
  };

  return (
    <div className="container mt-4">
    <section className="content container-fluid mt-4">
      {view === "form" ? (
        <form onSubmit={handleSubmit}>
          <center>
            
                      <div className="form-group" style={{ paddingTop: 10 }}>
                        <span>Class Name</span>
                        <select
                          className="form-control"
                          value={className}
                          onChange={(e) => setClassName(e.target.value)}
                        >
                          {["6", "7", "8", "9", "10"].map((cls) => (
                            <option key={cls} value={cls}>
                              {cls} th Class
                            </option>
                          ))}
                        </select>
                   </div>

                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-md-offset-4 col-lg-offset-4 col-sm-offset-4">
                  <div className="form-group" style={{ paddingTop: 10 }}>
                    <span>Subject</span>
                    <input
                      className="form-control"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      type="text"
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-md-offset-4 col-lg-offset-4 col-sm-offset-4">
                  <div className="form-group" style={{ paddingTop: 10 }}>
                    <span>Link URL</span>
                    <input
                      className="form-control"
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                      type="text"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-md-offset-4 col-lg-offset-4 col-sm-offset-4">
                    <div className="form-group" style={{ paddingTop: 10 }}>
                      <button
                        type="submit"
                        className="btn btn-primary form-control"
                      >
                        {editingId ? "Update" : "Save"}
                      </button>
                      <br />
                      <button
                        type="button"
                        className="btn btn-secondary mt-2"
                        onClick={() => {
                          setView("grid");
                          setSubject("");
                          setUrl("");
                          setEditingId(null);
                        }}
                      >
                        Cancel
                      </button>
                      </div>
              </div>
            </div>
          </center>
        </form>
      ) : (
        <section className="content container-fluid mt-4">
          <div className="row">
            <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
              <div className="box box-primary">
                <div className="box-header with-border d-flex justify-content-between align-items-center">
                  <div className="box-header with-border d-flex justify-content-between align-items-center">
                    <h3 className="box-title">Class Links</h3>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => setView("form")}
                    >
                      Add New
                    </button>
                  </div>
                  <table className="table table-bordered">
                    <thead className="thead-dark">
                      <tr>
                        <th>Class</th>
                        <th>Subject</th>
                        <th>Link URL</th>
                        <th style={{ width: "180px" }}>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {dataList.length === 0 ? (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No entries found.
                          </td>
                        </tr>
                      ) : (
                        dataList.map((item) => (
                          <tr key={item.id}>
                            <td>{item.className}th Class</td>
                            <td>{item.subject}</td>
                            <td>
                              <a
                                href={item.url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {item.url}
                              </a>
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-primary me-2"
                                onClick={() => handleEdit(item)}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleDelete(item.id)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </section>
    </div>
  );
};

export default LinkUploader;
